'use client';
import { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { DialogTrigger } from '@radix-ui/react-dialog';
import { getCookie } from 'cookies-next';
import ErrorIcon from '@/components/customercenter-ui/svgs/notifications/error';
import PaymentGuardianIcon from '@/components/customercenter-ui/svgs/paymentGuardian';
import { useAccount } from '@/frontastic';
import { ErrorNotification } from '@/helpers/utils/notification';
import { getCurrentCentralTime, getCurrentDateTime } from '@/helpers/utils/siteUtils';
import { EnrollProtectionPayload } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import { COOKIE_KEYS, DEFAULT_AGENT_NAME, DEFAULT_INITIATING_SYSTEM } from '../../../../../constants/constant';
import { PAYLOAD_QUERY } from '../../customer-detail/constants';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import Loader from '../../ui/loader';
import { useToast } from '../../ui/use-toast';

const AddPaymentGuardianModal = ({ setModalOpen, Texts, paymentGuardianData, setData }: any) => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [added, setAdded] = useState(false);
  const params = useSearchParams();
  const { enrollCreditProtection } = useAccount();
  const [loading, setLoading] = useState(false);

  const submitEnrollCreditProtection = async () => {
    setLoading(true);
    const data = JSON.parse(getCookie(COOKIE_KEYS.CDP_URL) ?? '');
    const customerId = data?.customerId ?? '';
    const divisionCode = data?.divisionCode ?? '';

    const payload = {
      omsCustomerId: params.get(PAYLOAD_QUERY?.OMS_CUSTOMER_ID) ?? customerId,
      divisionCode: params.get(PAYLOAD_QUERY?.DIVISION_CODE) ?? divisionCode,
      initiatingAgent: DEFAULT_AGENT_NAME,
      initiatingSystem: DEFAULT_INITIATING_SYSTEM,
      initiatedOn: getCurrentCentralTime(),
    } as EnrollProtectionPayload;

    await enrollCreditProtection(payload).then((res) => {
      if (res?.code === 'OK') {
        setAdded(true);
        setData(() => [
          {
            cancelledOn: '',
            enrollmentStatus: 'Enrolled',
            isEligible: true,
            isEnrolled: true,
            enrolledOn: getCurrentDateTime(),
          },
        ]);
      } else {
        ErrorNotification(toast, {
          description: paymentGuardianData?.paymentGuardianErrorMessage,
          action: <ErrorIcon className="h-5 w-5" />,
        });
      }
      setLoading(false);
    });
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        if (value) {
          setAdded(false);
        }
      }}
    >
      <DialogTrigger className="rounded-md bg-deepBlue px-4 py-2 text-white">{Texts.learnMore}</DialogTrigger>
      <DialogContent className="max-w-[466px] bg-white sm:rounded-md">
        {loading && <Loader />}
        <DialogHeader>
          <DialogTitle className="flex justify-center text-2xl font-bold">
            <PaymentGuardianIcon />
          </DialogTitle>
        </DialogHeader>
        <section className="my-4 max-h-[360px] overflow-y-auto px-2 text-center">
          {!added ? (
            <p>{paymentGuardianData?.paymentGuardianAgreement}</p>
          ) : (
            <p>{paymentGuardianData?.paymentGuardianSuccessMessage}</p>
          )}
        </section>
        <section className="mt-4 flex justify-center gap-4">
          {!added ? (
            <>
              <Button className="rounded-md bg-deepBlue p-4 text-white" onClick={() => submitEnrollCreditProtection()}>
                {Texts.addPaymentGuardian}
              </Button>
              <Button className="p-0 underline" onClick={() => setOpen(false)}>
                {Texts.cancelButton}
              </Button>{' '}
            </>
          ) : (
            <Button
              className="rounded-md bg-deepBlue p-4 px-6 text-lg text-white"
              onClick={() => {
                setOpen(false);
                setAdded(false);
                setModalOpen(false);
              }}
            >
              {Texts.close}
            </Button>
          )}
        </section>
      </DialogContent>
    </Dialog>
  );
};

export default AddPaymentGuardianModal;
